import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router'

import { HomePage } from '../pages/HomePage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { Layout } from './Layout'

// Buyer and seller surfaces are separate chunks: buyers arriving from a
// WhatsApp link never download Studio code (low-bandwidth budget).
const TryPage = lazy(() => import('../pages/TryPage'))
const ProductPage = lazy(() => import('../pages/ProductPage'))
const StudioPage = lazy(() => import('../pages/StudioPage'))
const LookPage = lazy(() => import('../pages/LookPage'))
const AdminPage = lazy(() => import('../pages/AdminPage'))
const ShopPage = lazy(() => import('../pages/ShopPage'))
const PosterPage = lazy(() => import('../pages/PosterPage'))
const LegalPage = lazy(() => import('../pages/LegalPage'))

export const routes: RouteObject[] = [
  // Printable poster, without site chrome.
  {
    path: 'poster/:kind/:id',
    element: (
      <Suspense fallback={null}>
        <PosterPage />
      </Suspense>
    ),
  },
  // Full-screen operator shell, outside the public layout.
  {
    path: 'admin/*',
    element: (
      <Suspense
        fallback={
          <output className="loading">
            <span className="spinner" aria-hidden="true" />
          </output>
        }
      >
        <AdminPage />
      </Suspense>
    ),
  },
  {
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'try', element: <TryPage /> },
      { path: 'p/:token', element: <ProductPage /> },
      { path: 's/:slug', element: <ShopPage /> },
      { path: 'studio/*', element: <StudioPage /> },
      { path: 'l/:token', element: <LookPage /> },
      { path: 'privacy', element: <LegalPage doc="privacy" /> },
      { path: 'terms', element: <LegalPage doc="terms" /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
